import React from 'react';

const Numeric = ({ ...attrs }) => (
  <svg viewBox="0 0 150 74" {...attrs} width="1.2em">
    <g transform="matrix(1.5,0,0,1.5,-37.425,-75.275)">
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 3,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        d="m27.3 97.2v-4.8h10.2v-32.9h-8.1v-3.7c2.1-0.4 3.8-0.8 5.4-1.4 1.5-0.5 2.9-1.2 4.1-1.9h4.4v39.9h9.2v4.8z"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 3,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        d="m59.4 97.2v-3.4c3.4-3.4 6.3-6.4 9-9.1 2.6-2.7 4.8-5.2 6.6-7.5s3.1-4.4 4.1-6.4c0.9-1.9 1.4-3.8 1.4-5.6 0-2.6-0.7-4.7-2.1-6.3s-3.5-2.4-6.4-2.4c-1.9 0-3.6 0.5-5.2 1.6s-3 2.3-4.3 3.8l-3.3-3.3c1.9-2.1 3.9-3.7 6-4.9s4.6-1.9 7.6-1.9c4.2 0 7.4 1.2 9.8 3.6s3.6 5.6 3.6 9.6c0 2.1-0.5 4.2-1.4 6.3s-2.2 4.3-3.8 6.6-3.5 4.6-5.7 7.1-4.7 5.1-7.3 7.8c1.2-0.1 2.5-0.2 3.8-0.3s2.5-0.1 3.7-0.1h12.9v5h-29z"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 3,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        d="m107.9 98c-1.8 0-3.4-0.2-4.9-0.5-1.5-0.4-2.8-0.8-4-1.4s-2.3-1.2-3.3-2c-1-0.7-1.8-1.5-2.6-2.4l2.9-3.8c1.4 1.4 2.9 2.6 4.7 3.7s4 1.6 6.7 1.6 4.9-0.7 6.7-2.2c1.7-1.5 2.6-3.5 2.6-6 0-1.3-0.2-2.5-0.7-3.6s-1.3-2-2.4-2.8-2.6-1.4-4.4-1.8-4.1-0.6-6.7-0.6v-4.4c2.4 0 4.4-0.2 6-0.6s2.9-1 3.9-1.8c1-0.7 1.7-1.6 2.1-2.7 0.4-1 0.6-2.1 0.6-3.3 0-2.2-0.7-3.9-2.1-5.2s-3.3-1.9-5.6-1.9c-1.9 0-3.6 0.4-5.1 1.3-1.6 0.8-3 1.9-4.4 3.3l-3.1-3.6c1.7-1.6 3.6-3 5.7-4s4.4-1.6 7.1-1.6c2 0 3.8 0.3 5.4 0.8s3 1.2 4.2 2.2 2.1 2.1 2.8 3.5 1 3 1 4.8c0 2.7-0.7 4.9-2.2 6.7-1.5 1.7-3.5 3.1-5.9 4v0.3c1.4 0.3 2.6 0.8 3.8 1.4s2.2 1.4 3.1 2.4 1.6 2.1 2.1 3.3c0.5 1.3 0.7 2.7 0.7 4.2 0 2-0.4 3.7-1.2 5.3s-1.8 2.9-3.2 4-2.9 1.9-4.7 2.5-3.6 0.9-5.6 0.9z"
      />
    </g>
  </svg>
);

export default Numeric;
